/**
 * @generated SignedSource<<f04088d19646897cc6cb1a100e44a96f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityShowLessonPrices_facility$data = {
  readonly club: {
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly privateLessonsPermissionSet: {
    readonly showPrices: boolean | null | undefined;
  } | null | undefined;
  readonly publicLessonsPermissionSet: {
    readonly showPrices: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityShowLessonPrices_facility";
};
export type useFacilityShowLessonPrices_facility$key = {
  readonly " $data"?: useFacilityShowLessonPrices_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityShowLessonPrices_facility">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPrices",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityShowLessonPrices_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "publicLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PrivateLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "privateLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "ee40fc303c20510daf9e0954d3ebb56e";

export default node;
